<template>
    <div class="property-saved-searches-card-content d-flex align-items-center justify-content-between">
        <div class="information">
            <span
                    class="info-elem"
                    v-for="value of filledData"
                    :key="value"
            >
                {{ value }}
            </span>
        </div>
        <property-saved-searches-card-actions :property-search-filter-app-resource="propertySearchFilterAppResource" />
    </div>
</template>

<script>
    import './PropertySavedSearchesCardContent.scss';
    import PropertySavedSearchesCardActions from "../PropertySavedSearchesCardActions/PropertySavedSearchesCardActions";
    import PropertySearchFilterAppResource
        from "@milestoneslabs/milestones-core-js/src/AppResources/PropertySearchFilterAppResource";
    import {
        PRICES,
        SQUARE_FEET,
        LOT_SIZE,
        YEAR_BUILT,
        SALE_TYPES,
    } from "../../../../../helpers/filterOptions";
    import get from 'lodash/get';

    export default {
        name: "PropertySavedSearchesCardContent",

        components: {
            PropertySavedSearchesCardActions,
        },

        props: {
            propertySearchFilterAppResource: {
                type: PropertySearchFilterAppResource,
                required: true,
            }
        },

        data() {
            return {
                contentData: [],
            };
        },

        computed: {
            filledData() {
                let filledData = [];

                for (let key in this.contentData) {
                    let value = this.contentData[key];
                    if (value && String(value).length > 0) {
                        filledData.push(String(value));
                    }
                }

                return filledData;
            },
        },

        beforeMount() {
            this.retrieveData();
        },

        watch: {
            propertySearchFilterAppResource: {
                deep: true,
                handler(value) {
                    this.retrieveData();
                }
            }
        },

        methods: {
            async retrieveData() {
                let data = this.propertySearchFilterAppResource.data;
                this.contentData = {
                    search: get(data, 'search.value') ? data.search.label : null,
                    price: this.formatRange(data.price, PRICES, '$0'),
                    beds: get(data, 'beds.value') ? data.beds.label + ' Beds' : null,
                    baths: get(data, 'baths.value') ? data.baths.label + ' Baths' : null,
                    yearBuilt: this.formatRange(data.yearBuilt, YEAR_BUILT, '0'),
                    squareFeet: this.addCommaToNumbers(data.squareFeet, SQUARE_FEET, '0'),
                    homeTypes: this.getFilterLabel(data.homeTypes),
                    saleTypes: this.getFilterLabel(data.sale),
                    keywords: data.keywords.join(', '),
                    lotSize: this.formatRange(data.lotSize, LOT_SIZE) ?
                        this.addCommaToNumbers(data.lotSize, LOT_SIZE, '0') + ' Lot Size' : null,
                    includePending: 'Pending & Under Contract: ' + (data.includePending ? 'Yes' : 'No'),
                };
            },

            getFilterLabel(items) {
                if (!items.length) {
                    return null;
                }

                let types = [];
                for (let type of items) {
                    types.push(type.label);
                }

                return types.join(', ');
            },

            formatRange(rangeObj, filterOption, defaultMin = null) {
                let min = get(rangeObj, 'min.value', null);
                let max = get(rangeObj, 'max.value', null);
                if (!min && !max) {
                    return null;
                }

                if (!min) {
                    return (defaultMin ? defaultMin : filterOption.min.find(item => item.value === 0).label)
                        + ' - ' + rangeObj.max.label;
                }

                if (!max) {
                    return rangeObj.min.label + '+';
                }

                return rangeObj.min.label + ' - ' + rangeObj.max.label;
            },

            addCommaToNumbers(rangeObj, filterOption, defaultMin = null)
            {
                return (this.formatRange(rangeObj, filterOption, defaultMin) || '')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
        },
    };
</script>
